<template>
  <div class="about-us-component">
    <div class="section-2">
      <el-row>
        <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">&nbsp; </el-col>

        <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20">
          <div class="">
            <p>
              StockAnts is a marketplace for price estimates. We aggregate SEBI Registered experts’ research with price estimate tracking to help retail users to decide & trade with their broker by making an investment decision.
            </p>
          </div>
          
          <div class="special-sec">
            <h1> Track Price estimate tracking</h1>
            <p>
              Get SEBI Registered experts’ price estimates for Equity, Options & Equity baskets
            </p>
          </div>
          <div class="special-sec">
            <h1>Trust Verified SEBI Registered Experts</h1>
            <p>
              Build trust on SEBI Registered experts on the basis of their performance track record
            </p>
          </div>
          <div class="special-sec">
            <h1>Trade</h1>
            <p>
              Trade with your broker credentials via StockAnts Platform
            </p>
          </div>
        </el-col>

        <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">&nbsp; </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>

export default {
  name: "AboutUsComponent",

  components: {},

  mixins: [],

  data() {
    return {
    };
  },

  methods: {},

  computed: {},
};
</script>
<style lang="scss" scoped>
.about-us-component {
  .section-2 {
    .special-sec {
      margin: 60px 0;
    }

    h1 {
      font-size: 1.2rem;
      font-weight: 600;
      color: #25246a;
    }

    p {
      font-size: 0.9rem;
      color: #6d6a6a;
    }

    ul {
      list-style: none;

      li {
        font-size: 0.9rem;
        margin: 10px 0;
        color: #6d6a6a;
      }

      li::before {
        content: "\2022";
        color: #322e79;
        font-weight: bold;
        width: 1em;
        margin-left: -1em;
        font-size: 45px;
        position: relative;
        margin-right: 25px;
        top: 7px;
      }
    }

    @media screen and (max-width: 876px) {
      .section-2 {
        padding: 0 70px;
      }
    }

    @media screen and (max-width: 600px) {
      .section-2 {
        padding: 0 35px;
      }
    }

    @media screen and (max-width: 450px) {
      .section-2 {
        padding: 0 20px;
      }
    }
  }
}</style>